// ==============================|| LIST OVERRIDES ||============================== //

export default function List(theme) {
  return {
    MuiList: {
      styleOverrides: {
        root: {},
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          '& .MuiTouchRipple-root': {
            color: theme.palette.error.main,
          },
        },
      },
    },
  };
}
